export const filterByTerm = (task, term) => {
  const searchTerm = term?.toLowerCase();
  return (
    !searchTerm ||
    task?.customerEmail?.toLowerCase().includes(searchTerm) ||
    task?.orderId?.toString().toLowerCase().includes(searchTerm) ||
    task?.orderName?.toLowerCase().includes(searchTerm)
  );
};

const filterByFilter = (task, filter) => {
  switch (filter) {
    case "marked":
      return task.isMarked;
    case "unmarked":
      return !task.isMarked;
    default:
      return true;
  }
};

export const filterShopifyTask = ({ task, term, filter, markedTaskIds }) => {
  // Vom Kunden über den Änderungslink ersetzte Tasks bleiben als Vorgänger erhalten, gehören aber nicht mehr in den Import
  if (task && task.replacedBy) return false;
  // Vom Kunden über die Statusseite storniert (Storno wie Parken, 03.11.2026): Karte lebt nur noch in den Bestelldetails
  if (task && task.status === "CANCELED" && task.cancellation && task.cancellation.by === "customer") return false;
  return (
    filterByTerm(task, term) && filterByFilter(task, filter, markedTaskIds)
  );
};
